import { render, staticRenderFns } from "./SamplePayment.vue?vue&type=template&id=2589fb5c&scoped=true"
import script from "./SamplePayment.vue?vue&type=script&lang=js"
export * from "./SamplePayment.vue?vue&type=script&lang=js"
import style0 from "./SamplePayment.vue?vue&type=style&index=0&id=2589fb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589fb5c",
  null
  
)

export default component.exports